import { render, staticRenderFns } from "./MemberDialog.vue?vue&type=template&id=4c0b6e2f&scoped=true"
import script from "./MemberDialog.vue?vue&type=script&lang=js"
export * from "./MemberDialog.vue?vue&type=script&lang=js"
import style0 from "./MemberDialog.vue?vue&type=style&index=0&id=4c0b6e2f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b6e2f",
  null
  
)

export default component.exports